// ================================================================
// Mapa Inverso — schema, chip options, OPPOSITE_MAP and helpers
// ================================================================

export const CRISIS_KEYWORDS = [
    "suicid",
    "matarme",
    "matar a mi",
    "no quiero vivir",
    "no quiero seguir",
    "quitarme la vida",
    "acabar con todo",
    "acabar conmigo",
    "autolesion",
    "autolesión",
    "cortarme",
    "cortes en",
    "quitarme de en medio",
    "hacerme daño",
    "hacerme dano",
    "no aguanto más",
    "no aguanto mas",
    "terminar con mi vida",
    "desaparecer para siempre",
    "ideas suicidas",
    "ya no hay salida",
];

export function scanCrisis(value) {
    if (value == null) return false;
    if (typeof value === "string") {
        const s = value.toLowerCase();
        return CRISIS_KEYWORDS.some((k) => s.includes(k));
    }
    if (Array.isArray(value)) return value.some(scanCrisis);
    if (typeof value === "object")
        return Object.values(value).some(scanCrisis);
    return false;
}

// ----------------------------------------------------------------
// STEP STRUCTURE — 0 welcome · 1..8 questionnaire · 9 result+identity
// ----------------------------------------------------------------
export const STEPS = [
    { id: "welcome", code: "00", title: "Bienvenido al espejo", kicker: "Apertura" },
    { id: "starting", code: "01", title: "Punto de partida", kicker: "Diagnóstico inicial" },
    { id: "signals", code: "02", title: "Primera señal", kicker: "¿Cómo empieza tu ruta?" },
    { id: "emotions", code: "03", title: "Emoción dominante", kicker: "¿Qué emoción empuja?" },
    { id: "lies", code: "04", title: "Mentira principal", kicker: "Las frases del autoengaño" },
    { id: "triggers", code: "05", title: "Lugares · personas · horarios", kicker: "Cartografía del riesgo" },
    { id: "consequences", code: "06", title: "Consecuencias", kicker: "Lo que ya pagaste" },
    { id: "immediate_exit", code: "07", title: "Salida inmediata", kicker: "Ruta contraria · hoy" },
    { id: "recovery_system", code: "08", title: "Sistema de recuperación", kicker: "Base que sostiene" },
    { id: "result", code: "09", title: "Tu Mapa Inverso", kicker: "Expediente final" },
];

// ----------------------------------------------------------------
// Step 1 — Punto de partida
// ----------------------------------------------------------------
export const ESTADO_OPTIONS = [
    "Estoy consumiendo",
    "Estoy intentando parar",
    "Estoy en tratamiento",
    "Estoy en recuperación",
    "Estoy acompañando a alguien",
];

export const URGENCIA_OPTIONS = [
    { value: "Bajo", tone: "muted" },
    { value: "Medio", tone: "warning" },
    { value: "Alto", tone: "danger" },
    { value: "Estoy en riesgo ahora", tone: "danger", critical: true },
];

// ----------------------------------------------------------------
// Step 2 — Primera señal
// ----------------------------------------------------------------
export const SIGNAL_OPTIONS = [
    "Me aíslo",
    "Dejo de hablar",
    "Me irrito si me preguntan",
    "Dejo hábitos",
    "Duermo mal",
    "Como mal o dejo de comer",
    "Empiezo a mentir",
    "Busco excusas",
    "Contacto gente negativa",
    "Pienso mucho en consumir",
    "Me expongo a lugares de riesgo",
    "Me siento demasiado confiado",
];

// ----------------------------------------------------------------
// Step 3 — Emociones
// ----------------------------------------------------------------
export const EMOTION_OPTIONS = [
    "Soledad",
    "Vergüenza",
    "Culpa",
    "Rabia",
    "Ansiedad",
    "Vacío",
    "Aburrimiento",
    "Rechazo",
    "Frustración",
    "Miedo",
    "Euforia",
    "Cansancio",
    "Sensación de fracaso",
];

// ----------------------------------------------------------------
// Step 4 — Mentiras
// ----------------------------------------------------------------
export const LIE_OPTIONS = [
    "Yo lo controlo",
    "Solo será una vez",
    "Mañana paro",
    "Me lo merezco",
    "Nadie se dará cuenta",
    "No estoy tan mal",
    "Puedo juntarme con ellos y no consumir",
    "Puedo tomar sin pasar a otras drogas",
    "Ya estoy bien",
    "Esta vez será distinto",
    "Total, ya la cagué",
    "No daño a nadie",
];

// ----------------------------------------------------------------
// Step 5 — Lugares / Personas / Horarios
// ----------------------------------------------------------------
export const PLACE_OPTIONS = [
    "Casa solo",
    "Baños",
    "Fiestas",
    "Moteles",
    "Bares",
    "Calles específicas",
    "Casa de amigos",
    "Trabajo",
    "Redes sociales",
    "Aplicaciones de citas",
];

export const PEOPLE_OPTIONS = [
    "Dealers",
    "Amigos de consumo",
    "Expareja",
    "Compañeros de fiesta",
    "Personas que minimizan mi problema",
    "Personas con quienes miento fácil",
];

export const HOURS_OPTIONS = [
    "Noche",
    "Fines de semana",
    "Después de cobrar",
    "Después de una pelea",
    "Después de una buena noticia",
    "Cuando estoy solo",
    "Cuando estoy cansado",
];

// ----------------------------------------------------------------
// Step 6 — Consecuencias
// ----------------------------------------------------------------
export const CONSEQ_BODY = [
    "Insomnio",
    "Baja de peso",
    "Aumento de peso",
    "Nariz dañada",
    "Cansancio",
    "Ansiedad física",
    "Dolor de cabeza",
    "Gastritis o acidez",
    "Falta de higiene",
    "Pérdida de deseo sexual",
];

export const CONSEQ_BONDS = [
    "Peleas",
    "Decepción",
    "Pérdida de confianza",
    "Distancia con hijos",
    "Ruptura de pareja",
    "Familia vigilando",
    "Familia cerrando puertas",
    "Aislamiento",
];

export const CONSEQ_MONEY = [
    "Deudas",
    "Robos",
    "Perder trabajo",
    "Gastar lo que no tengo",
    "No pagar responsabilidades",
    "Vender cosas",
    "Pedir prestado",
];

export const CONSEQ_DIGNITY = [
    "No reconocerme",
    "Vergüenza",
    "Culpa",
    "Mentir",
    "Manipular",
    "Sentir que perdí mi esencia",
    "Ideas suicidas",
    "Sentir que ya no hay salida",
];

// ----------------------------------------------------------------
// Step 7 — Salida inmediata
// ----------------------------------------------------------------
export const EXIT_ACTION_OPTIONS = [
    "Llamar antes de aislarme",
    "Salir a caminar",
    "Comer algo",
    "Tomar agua",
    "Ducharme",
    "Ir a un lugar seguro",
    "Bloquear contacto",
    "Avisar que estoy en riesgo",
    "Escribir lo que siento",
    "Ir a reunión",
    "Pedir que no me dejen solo",
];

export const ANCHOR_PHRASES = [
    "La recaída no empieza con la droga, empieza cuando vuelvo a mentirme.",
    "Si tengo que controlarlo, ya hay un problema.",
    "Hoy no negocio con mi versión adicta.",
    "Sentirme bien no significa estar recuperado.",
    "No tengo que destruirme para calmarme.",
    "Mi mapa viejo no decide por mí.",
    "Solo por hoy camino en dirección contraria.",
];

// ----------------------------------------------------------------
// Step 8 — Sistema de recuperación
// ----------------------------------------------------------------
export const BASE_HABITS = [
    "Levantarme temprano",
    "Ordenar mi día",
    "Hacer ejercicio 20 minutos",
    "Comer tres veces",
    "Dormir a horario",
    "Leer mi mapa",
    "Terapia semanal",
    "Grupo de apoyo",
    "Meditar",
    "Escribir diario",
];

export const STRUCTURAL_LIMITS = [
    "No tener efectivo",
    "No salir solo de noche",
    "Bloquear dealers",
    "No ver amigos de consumo",
    "No entrar a bares/fiestas",
    "Entregar tarjetas temporalmente",
    "No discutir en crisis",
    "Salir del lugar de riesgo",
    "Avisar si aparece craving",
];

// ----------------------------------------------------------------
// COUNTRIES (identity — optional)
// ----------------------------------------------------------------
export const COUNTRIES = [
    "Chile",
    "Argentina",
    "México",
    "Colombia",
    "Perú",
    "España",
    "Uruguay",
    "Ecuador",
    "Bolivia",
    "Paraguay",
    "Venezuela",
    "Estados Unidos",
    "Otro",
];

// ----------------------------------------------------------------
// Empty answers shape
// ----------------------------------------------------------------
const emptyChip = () => ({ selected: [], otro: "" });

export const EMPTY_ANSWERS = {
    starting: {
        sustancia: "",
        estado: "",
        urgencia: "",
    },
    signals: emptyChip(),
    emotions: emptyChip(),
    lies: emptyChip(),
    triggers: {
        places: emptyChip(),
        people: emptyChip(),
        hours: emptyChip(),
    },
    consequences: {
        body: emptyChip(),
        bonds: emptyChip(),
        money: emptyChip(),
        dignity: emptyChip(),
    },
    attempts: {
        intentos_count: "",
    },
    immediate_exit: {
        persona_segura: "",
        actions: emptyChip(),
        limite: "",
        anchor: emptyChip(),
    },
    recovery_system: {
        habits: emptyChip(),
        limits: emptyChip(),
        proposito: "",
    },
};

// ----------------------------------------------------------------
// OPPOSITE_MAP — Ruta vieja → Acción contraria
// ----------------------------------------------------------------
export const OPPOSITE_MAP = {
    // signals
    "Me aíslo": "Avisar a una persona segura antes de quedarme solo",
    "Dejo de hablar": "Decir una frase honesta al día, aunque sea incómoda",
    "Me irrito si me preguntan": "Agradecer la pregunta antes de defenderme",
    "Dejo hábitos": "Volver a una rutina mínima de recuperación",
    "Duermo mal": "Higiene del sueño: pantalla off, horario fijo, ayuda si dura",
    "Como mal o dejo de comer": "Tres comidas básicas pactadas con alguien",
    "Empiezo a mentir": "Decir la verdad antes de que la culpa se convierta en excusa",
    "Busco excusas": "Reconocer la excusa en voz alta y nombrarla",
    "Contacto gente negativa": "Bloquear contactos de riesgo por 30 días",
    "Pienso mucho en consumir": "Comunicarlo antes de actuar",
    "Me expongo a lugares de riesgo": "Cambiar de ruta antes de pasar",
    "Me siento demasiado confiado": "Recordar: si tengo que controlarlo, ya hay un problema",

    // emotions
    "Soledad": "Llamar primero, consumir nunca",
    "Vergüenza": "Decir la verdad antes de ocultarme",
    "Culpa": "Aceptarla sin pagarla con más consumo",
    "Rabia": "Mover el cuerpo antes de tomar una decisión",
    "Ansiedad": "Respiración 4-7-8 antes de buscar alivio rápido",
    "Vacío": "Estructurar la siguiente hora con una acción concreta",
    "Aburrimiento": "Crear estructura diaria",
    "Rechazo": "No pedir afecto a quien ya dijo que no",
    "Frustración": "Escribir lo que siento sin filtros antes de actuar",
    "Miedo": "Nombrar el miedo en voz alta a alguien que confío",
    "Euforia": "Frenar antes de celebrar con sustancias",
    "Cansancio": "Dormir antes de cualquier otra decisión",
    "Sensación de fracaso": "Recordar: hoy es un día, no toda la vida",

    // lies
    "Yo lo controlo": "Si tengo que controlarlo, ya hay un problema",
    "Solo será una vez": "Una sola vez ya destruyó cosas antes",
    "Mañana paro": "Mañana es hoy mintiéndome",
    "Me lo merezco": "Merezco mantenerme, no recaer",
    "Nadie se dará cuenta": "Yo me daré cuenta, eso ya alcanza",
    "No estoy tan mal": "El 'no tan mal' fue mi entrada todas las veces",
    "Puedo juntarme con ellos y no consumir": "No voy a probarme con ellos hoy",
    "Puedo tomar sin pasar a otras drogas": "Una sustancia abre la puerta a todas",
    "Ya estoy bien": "Sentirme bien no significa estar recuperado",
    "Esta vez será distinto": "Esta vez tampoco. Mi mapa lo dice",
    "Total, ya la cagué": "La recaída no obliga a otra. Paro acá",
    "No daño a nadie": "Me daño a mí. Eso ya es daño",

    // places
    "Casa solo": "No quedarme solo en horarios críticos",
    "Baños": "Avisar antes de encerrarme si estoy mal",
    "Fiestas": "No ir a eventos de consumo por 60 días",
    "Moteles": "Bloquear apps de citas y reservas",
    "Bares": "Cambiar mi camino para no pasar por bares",
    "Calles específicas": "Rutas alternativas obligatorias",
    "Casa de amigos": "No visitar amigos de consumo",
    "Trabajo": "Identificar y evitar el rincón de riesgo",
    "Redes sociales": "Silenciar cuentas y grupos de riesgo",
    "Aplicaciones de citas": "Desinstalar por al menos 30 días",

    // people
    "Dealers": "Bloquear todos los contactos. Sin excepciones",
    "Amigos de consumo": "Bloquear o cortar contacto",
    "Expareja": "Cero contacto si activa el ciclo",
    "Compañeros de fiesta": "No vernos en contexto de consumo",
    "Personas que minimizan mi problema": "Buscar otro tipo de apoyo",
    "Personas con quienes miento fácil": "No estar a solas con ellas",

    // hours
    "Noche": "Llegar a la cama temprano, sin pantalla",
    "Fines de semana": "Agenda obligatoria con personas sanas",
    "Después de cobrar": "Proteger el dinero y limitar acceso a efectivo",
    "Después de una pelea": "Llamar a mi persona segura antes de decidir",
    "Después de una buena noticia": "Celebrar sin sustancias, con quien me cuida",
    "Cuando estoy solo": "Buscar compañía o lugar público antes",
    "Cuando estoy cansado": "Comer, dormir, postergar decisiones",

    // consequences — body
    "Insomnio": "Higiene del sueño estricta · médico si persiste",
    "Baja de peso": "Tres comidas pactadas, supervisión médica",
    "Aumento de peso": "Caminata diaria mínima",
    "Nariz dañada": "Chequeo médico esta semana",
    "Ansiedad física": "Respiración + reducir estímulos",
    "Dolor de cabeza": "Agua, descanso, médico si persiste",
    "Gastritis o acidez": "Comida regular, control médico",
    "Falta de higiene": "Ducha y ropa limpia, todos los días",
    "Pérdida de deseo sexual": "No forzar, conversar con pareja",

    // consequences — bonds
    "Peleas": "Pausa antes de discutir",
    "Decepción": "Hechos pequeños, no promesas grandes",
    "Pérdida de confianza": "Reconstruir con consistencia, no con discursos",
    "Distancia con hijos": "Presencia, no perfección. Acuerdos breves",
    "Ruptura de pareja": "Respetar el espacio. Trabajar en mí",
    "Familia vigilando": "Aceptar los límites sin discutir",
    "Familia cerrando puertas": "Recuperar con hechos, no con palabras",
    "Aislamiento": "Una llamada al día, mínimo",

    // consequences — money
    "Deudas": "Plan de pago realista, paso a paso",
    "Robos": "Restituir lo que se pueda, reconocer lo demás",
    "Perder trabajo": "Plan B antes que excusas",
    "Gastar lo que no tengo": "Tarjetas entregadas temporalmente",
    "No pagar responsabilidades": "Listar y priorizar lo urgente",
    "Vender cosas": "Pedir ayuda antes de vender lo siguiente",
    "Pedir prestado": "Cero préstamos por 90 días",

    // consequences — dignity
    "No reconocerme": "Mirarme al espejo y nombrar una verdad cada día",
    "Mentir": "Decir la verdad antes de inventar la siguiente",
    "Manipular": "Pedir, no presionar",
    "Sentir que perdí mi esencia": "Hacer una cosa pequeña que sí soy yo",
    "Ideas suicidas": "Llamar ayuda profesional ahora. 600 360 7777 / *4141",
    "Sentir que ya no hay salida": "Hablar con alguien antes de cerrar la puerta",
};

// Helper — get the opposite action for a chip text (returns null if not found)
export function getOpposite(text) {
    return OPPOSITE_MAP[text] || null;
}

// Helper — given a {selected, otro} chip object, return array of all values
export function chipValues(chip) {
    if (!chip) return [];
    const arr = [...(chip.selected || [])];
    if (chip.otro && chip.otro.trim()) arr.push(chip.otro.trim());
    return arr;
}

// ----------------------------------------------------------------
// Build the comparative routes (infierno → salida) from answers
// Returns { infierno: {...}, salida: {...}, comparison: [{old, new}], plan24h: [...] }
// ----------------------------------------------------------------
export function buildMaps(answers) {
    const signals = chipValues(answers.signals);
    const emotions = chipValues(answers.emotions);
    const lies = chipValues(answers.lies);
    const places = chipValues(answers.triggers?.places);
    const people = chipValues(answers.triggers?.people);
    const hours = chipValues(answers.triggers?.hours);
    const conseqBody = chipValues(answers.consequences?.body);
    const conseqBonds = chipValues(answers.consequences?.bonds);
    const conseqMoney = chipValues(answers.consequences?.money);
    const conseqDignity = chipValues(answers.consequences?.dignity);

    const allOldRoute = [
        ...signals.map((v) => ({ category: "Señal", old: v })),
        ...emotions.map((v) => ({ category: "Emoción", old: v })),
        ...lies.map((v) => ({ category: "Mentira", old: v })),
        ...places.map((v) => ({ category: "Lugar", old: v })),
        ...people.map((v) => ({ category: "Persona", old: v })),
        ...hours.map((v) => ({ category: "Horario", old: v })),
        ...conseqBody.map((v) => ({ category: "Cuerpo", old: v })),
        ...conseqBonds.map((v) => ({ category: "Vínculos", old: v })),
        ...conseqMoney.map((v) => ({ category: "Dinero", old: v })),
        ...conseqDignity.map((v) => ({ category: "Dignidad", old: v })),
    ];

    const comparison = allOldRoute.map((row) => ({
        ...row,
        new: getOpposite(row.old) || "Definir mi propia acción contraria",
    }));

    const infierno = {
        sustancia: answers.starting?.sustancia || "—",
        estado: answers.starting?.estado || "—",
        urgencia: answers.starting?.urgencia || "—",
        signals,
        emotions,
        lies,
        places,
        people,
        hours,
        consequences: {
            cuerpo: conseqBody,
            vinculos: conseqBonds,
            dinero: conseqMoney,
            dignidad: conseqDignity,
        },
    };

    const exitActions = chipValues(answers.immediate_exit?.actions);
    const exitAnchors = chipValues(answers.immediate_exit?.anchor);
    const habits = chipValues(answers.recovery_system?.habits);
    const limits = chipValues(answers.recovery_system?.limits);

    const salida = {
        persona_segura: answers.immediate_exit?.persona_segura || "—",
        acciones: exitActions,
        limite: answers.immediate_exit?.limite || "—",
        frases_ancla: exitAnchors,
        habitos: habits,
        limites_estructurales: limits,
        proposito: answers.recovery_system?.proposito || "—",
    };

    const plan24h = [
        "No me aíslo",
        "Aviso a mi persona segura",
        "Como algo y tomo agua",
        "Me alejo del lugar de riesgo",
        "Bloqueo contactos de consumo",
        "Leo mi frase ancla",
        "Espero 30 minutos antes de decidir",
        "Contacto terapeuta, grupo o ayuda profesional",
        "Si hay riesgo de daño, busco ayuda urgente",
    ];

    return { infierno, salida, comparison, plan24h };
}
